import { c as _c } from "react/compiler-runtime";
import { MemberProfileEmptyPage } from "@components/common/empty-page/member-profile-empty-page";
import { MemberGroupsTable } from "@components/common/member/member-groups-table";
import { MemberGroupsSkeleton } from "@components/common/skeleton-loading/member-profile-skeleton";
import { Text } from "@flat-ui";
/**
 * The groups of the member on their profile, or why they are not shown. Only reached once the
 * profile was shown, so a later fetch of the groups, e.g. once a Sphere XG seat was taken away, is
 * told apart from a member that belongs to no group.
 */
export function MemberProfileGroups(t0) {
  const $ = _c(5);
  const {
    member,
    groups,
    status
  } = t0;
  if (status === "rejected") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Text variant="bodyM" sx={{
        color: "text.secondary",
        pt: 2
      }}>Couldn't load the groups of this member. Reload the page to try again.</Text>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (status !== "succeeded") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <MemberGroupsSkeleton />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== groups || $[3] !== member) {
    t1 = groups.length === 0 ? <MemberProfileEmptyPage member={member} /> : <MemberGroupsTable groups={groups} member={member} />;
    $[2] = groups;
    $[3] = member;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}